import { useEffect } from "react";

declare global {
	interface Window {
		fbAsyncInit?: () => void;
		FB?: any;
		fbq?: any;
		_fbq?: any;
	}
}

export const useMetaPixel = () => {
	const pixelId = 612600021144011;
	const facebookAppId = 1786134982227545;

	useEffect(() => {
		// Define the fbAsyncInit function if Facebook App ID is provided
		if (facebookAppId) {
			window.fbAsyncInit = function () {
				window.FB?.init({
					appId: facebookAppId,
					cookie: true,
					xfbml: true,
					version: "v22.0",
				});

				window.FB?.AppEvents.logPageView();
			};
		}

		const injectMetaPixel = () => {
			// Check if the fbq function already exists
			if (window.fbq) return;

			// Create fbq function
			(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
				if (f.fbq) return;
				n = f.fbq = function () {
					n.callMethod
						? n.callMethod.apply(n, arguments)
						: n.queue.push(arguments);
				};
				if (!f._fbq) f._fbq = n;
				n.push = n;
				n.loaded = true;
				n.version = "2.0";
				n.queue = [];
				t = b.createElement(e);
				t.async = true;
				t.src = v;
				s = b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t, s);
			})(
				window,
				document,
				"script",
				"https://connect.facebook.net/en_US/fbevents.js"
			);

			// Initialize Meta Pixel
			window.fbq("init", pixelId);
			window.fbq("track", "PageView");
		};

		// Load the Facebook SDK script if Facebook App ID is provided
		const loadFacebookSDK = () => {
			if (!facebookAppId) return;

			const scriptId = "facebook-jssdk";
			if (document.getElementById(scriptId)) return;

			const js = document.createElement("script");
			js.id = scriptId;
			js.src = "https://connect.facebook.net/en_US/sdk.js";
			const fjs = document.getElementsByTagName("script")[0];
			fjs.parentNode?.insertBefore(js, fjs);
		};

		injectMetaPixel();
		loadFacebookSDK();
	}, [pixelId, facebookAppId]);
};
